<template>
  <!-- Leaderboard Section -->
  <section
    id="leaderboards"
    class="h-[2500px] md:h-[2700px] lg:h-[2700px] overflow-hidden leaderboard-bg relative bg-gradient-to-r from-[#04022E] via-[#04022E] to-[#04022E]"
  >
    <!-- <div class="absolute bg-black bg-opacity-30 top-0 left-0 w-full h-full max-h-[1024px] z-[2]"></div> -->
    <img
      src="../assets/leaderboard-bg.png"
      class="absolute top-0 md:bottom-[1320px] left-0 w-full h-full object-cover object-center max-h-[1024px] z-[1]"
    />
    <div class="flex items-center justify-center w-full px-4 md:px-0 lg:pt-0">
      <div
        class="w-full flex flex-col justify-center items-center my-8 md:my-10 md:mt-[120px] md:p-4 rounded-3xl z-10"
      >
        <div
          class="text-[#F25960] text-3xl md:text-4xl lg:text-4xl text-center leading-[48px] font-black"
          style="font-family: Montserrat, sans-serif"
        >
          <span
            class="bg-gradient-to-r from-[#01CCFF] to-[#9A36F8] text-transparent bg-clip-text uppercase"
          >
            {{ currentLeaderboard === "raingg" ? "rain.gg" : currentLeaderboard }}
            LEADERBOARD</span
          >
        </div>

        <div class="flex flex-col items-center justify-center my-10 lg:mt-20 lg:mb-5">
          <div class="bg-transparent">
            <div
              v-motion-slide-visible-bottom
              class="bg-transparent"
              style="font-family: Oxanium"
            >
              <!--  Timer -->
              <div
                v-if="currentLeaderboard && timer !== 'Leaderboard ended'"
                class="flex flex-row md:gap-x-2"
              >
                <!-- Days Timer -->
                <div
                  class="relative shadow-[0_0_50px_#9A36F8] rounded-full h-[84px] w-[84px] md:h-[100px] md:w-[100px]"
                >
                  <img
                    src="@/assets/countdown.png"
                    alt="Timer Background"
                    class="absolute inset-0 object-cover h-[84px] w-[84px] md:w-[100px] md:h-[100px]"
                  />
                  <div class="absolute inset-0 flex flex-col items-center justify-center">
                    <h4
                      class="text-white text-[36px] leading-[46px] font-bold text-center"
                    >
                      {{ timer.split(" ")[0].slice(0, -1) }}
                    </h4>
                    <h6 class="text-sm leading-6 font-bold text-center text-[#01CCFF]">
                      DAYS
                    </h6>
                  </div>
                </div>

                <!-- Hours Timer -->
                <div
                  class="relative shadow-[0_0_50px_#9A36F8] rounded-full h-[84px] w-[84px] md:h-[100px] md:w-[100px]"
                >
                  <img
                    src="@/assets/countdown.png"
                    alt="Timer Background"
                    class="absolute inset-0 object-cover h-[84px] w-[84px] md:h-[100px] md:w-[100px]"
                  />
                  <div class="absolute inset-0 flex flex-col items-center justify-center">
                    <h4
                      class="text-white text-[36px] leading-[46px] font-bold text-center"
                    >
                      {{ timer.split(" ")[1].slice(0, -1) }}
                    </h4>
                    <h6 class="text-sm leading-6 font-bold text-center text-[#01CCFF]">
                      HRS
                    </h6>
                  </div>
                </div>

                <!-- Minutes Timer -->
                <div
                  class="relative shadow-[0_0_50px_#9A36F8] rounded-full h-[84px] w-[84px] md:h-[100px] md:w-[100px]"
                >
                  <img
                    src="@/assets/countdown.png"
                    alt="Timer Background"
                    class="absolute inset-0 object-cover h-[84px] w-[84px] md:h-[100px] md:w-[100px]"
                  />
                  <div class="absolute inset-0 flex flex-col items-center justify-center">
                    <h4
                      class="text-white text-[36px] leading-[46px] font-bold text-center"
                    >
                      {{ timer.split(" ")[2].slice(0, -1) }}
                    </h4>
                    <h6 class="text-sm leading-6 font-bold text-center text-[#01CCFF]">
                      MIN
                    </h6>
                  </div>
                </div>

                <!-- Seconds Timer -->
                <div
                  class="relative shadow-[0_0_50px_#9A36F8] rounded-full h-[84px] w-[84px] md:h-[100px] md:w-[100px]"
                >
                  <img
                    src="@/assets/countdown.png"
                    alt="Timer Background"
                    class="absolute inset-0 object-cover h-[84px] w-[84px] md:h-[100px] md:w-[100px]"
                  />
                  <div class="absolute inset-0 flex flex-col items-center justify-center">
                    <h4
                      class="text-white text-[36px] leading-[46px] font-bold text-center"
                    >
                      {{ timer.split(" ")[3].slice(0, -1) }}
                    </h4>
                    <h6 class="text-sm leading-6 font-bold text-center text-[#01CCFF]">
                      SEC
                    </h6>
                  </div>
                </div>
              </div>

              <!-- Roobet Leaderboard Ended -->
              <div
                v-else
                class="text-white text-2xl md:text-[36px] md:leading-[48px] font-bold py-[11px]"
              >
                Leaderboard Ended
              </div>
            </div>
          </div>
        </div>

        <!-- Desktop leaderboard switch
        <div v-motion-pop-visible class="flex items-center justify-center my-10">
          <label
            class="relative flex items-center rounded-full w-full sm:w-[500px] h-[90px] lg:w-[600px] lg:h-[100px] p-1 border border-[rgba(255,255,255,0.2)] bg-gradient-to-bl from-[rgba(4, 2, 46,0.1)] to-[rgba(4, 2, 46,0.2)] backdrop-blur-[50px]"
          >
            Sliding Background
            <div
              class="absolute top-1 bottom-1 left-1 h-[calc(100%-8px)] rounded-full transition-all duration-300 ease-in-out"
              :class="{
                'bg-gradient-to-bl': true,
                'from-[rgba(255,255,255,0.1)]': true,
                'to-[rgba(221,221,221,0.1)]': true,
                'backdrop-blur-[50px]': true,
              }"
              :style="{
                width: 'calc(50% - 3px)',
                transform:
                  currentLeaderboard === 'roobet' ? 'translateX(0%)' : 'translateX(100%)',
              }"
            ></div>

            Roobet Logo Button
            <div
              class="z-20 flex items-center justify-center w-1/2 h-full transition-all rounded-full cursor-pointer"
              :class="{ 'bg-transparent': currentLeaderboard !== 'roobet' }"
              @click="toggleLeaderboard('roobet')"
            >
              <img
                src="@/assets/roobet-logo.png"
                alt="Roobet"
                class="h-[36px] md:h-[46px] w-auto object-contain"
              />
            </div>

            Packdraw Logo Button
            <div
              class="z-20 flex items-center justify-center w-1/2 h-full transition-all rounded-full cursor-pointer"
              :class="{ 'bg-transparent': currentLeaderboard !== 'packdraw' }"
              @click="toggleLeaderboard('packdraw')"
            >
              <img
                src="@/assets/packdraw-logo.png"
                alt="Packdraw"
                class="h-[38px] md:h-[52px] w-auto object-contain"
              />
            </div>
          </label>
        </div> -->

        <!-- Desktop leaderboard switch -->
        <div v-motion-pop-visible class="flex items-center justify-center my-10">
          <label
            class="relative flex items-center rounded-full w-[300px] sm:w-[400px] h-[90px] lg:w-[400px] lg:h-[100px] p-1 border border-[rgba(255,255,255,0.2)] bg-gradient-to-bl from-[rgba(4, 2, 46,0.1)] to-[rgba(4, 2, 46,0.2)] backdrop-blur-[50px]"
          >
            <!-- Sliding Background -->
            <div
              class="absolute top-1 bottom-1 left-1 h-[calc(100%-8px)] rounded-full transition-all duration-300 ease-in-out"
              :class="{
                'bg-gradient-to-bl': true,
                'from-[rgba(255,255,255,0.1)]': true,
                'to-[rgba(221,221,221,0.1)]': true,
                'backdrop-blur-[50px]': true,
              }"
              :style="{
                width: 'calc(99% - 3px)',
                transform:
                  currentLeaderboard === 'roobet' ? 'translateX(0%)' : 'translateX(100%)',
              }"
            ></div>

            <!-- Roobet Logo Button -->
            <div
              class="z-20 flex items-center justify-center w-full h-full transition-all rounded-full cursor-pointer"
              :class="{ 'bg-transparent': currentLeaderboard !== 'roobet' }"
              @click="toggleLeaderboard('roobet')"
            >
              <img
                src="@/assets/roobet-logo.png"
                alt="Roobet"
                class="h-[46px] md:h-[46px] w-auto object-contain"
              />
            </div>
          </label>
        </div>

        <div
          class="flex flex-col md:flex-row justify-center items-center mb-20 md:mb-[105px]"
        >
          <div class="block">
            <label
              class="toggle-switch md:mt-8 bg-transparent"
              style="font-family: Lato, sans-serif"
            >
              <input
                type="checkbox"
                @change="changeLeaderboard()"
                v-model="previousLeaderboard"
              />
              <div class="slider"></div>
              <div
                class="left-label relative py-4 md:py-6 w-[300px] h-[72px] rounded-[10px]"
                :class="{
                  'text-white': previousLeaderboard,
                  'text-[#0E0E0E]': !previousLeaderboard,
                }"
              >
                <img
                  :src="activeTabImage"
                  :class="previousLeaderboard === false ? 'hidden' : ''"
                  class="absolute top-0 right-0 w-[300px] h-[72px] z-10"
                />
                <p
                  class="absolute inset-0 top-5 text-center text-lg md:leading-[28px] font-extrabold z-20"
                >
                  CURRENT LEADERBOARD
                </p>
              </div>
              <div
                class="right-label relative py-4 md:py-6 w-[300px] h-[52px] md:h-[72px] rounded-[10px]"
                :class="{
                  'text-white': !previousLeaderboard,
                  'text-[#0E0E0E]': previousLeaderboard,
                }"
              >
                <img
                  :src="inActiveTabImage"
                  :class="previousLeaderboard && 'hidden'"
                  class="absolute top-0 right-0 w-[300px] h-[72px] z-10"
                />
                <p
                  class="absolute inset-0 top-5 text-center text-lg md:leading-[28px] font-extrabold z-20"
                >
                  PREVIOUS LEADERBOARD
                </p>
              </div>
            </label>
          </div>
        </div>

        <div
          v-if="loading == true"
          class="mt-10 text-xl font-bold text-center text-white md:text-4xl"
          style="font-family: Secular One, sans-serif"
        >
          Loading Leaderboard...
        </div>
        <div v-if="loading == false" class="relative w-full mt-24 md:mt-0">
          <div
            class="flex flex-row justify-center items-center mt-44 gap-[34px] md:gap-10 xl:gap-12 md:mb-16 lg:mb-0 lg:mt-16"
          >
            <div
              v-motion-pop-visible
              class="flex flex-col items-center mt-28 h-full md:h-[260px] lg:h-full md:mt-44 lg:mt-[88px] border-t border-b border-solid shadow-[4px_4px_30px_3px_rgba(154,54,248,1),-4px_-4px_30px_3px_rgba(154,54,248,1)]"
              style="border-image: linear-gradient(to left, #01ccff, #9a36f8) 1"
            >
              <div
                class="p-2.5 pb-[13px] md:pb-1 bg-gradient-to-r rounded-none w-[150px] md:w-[200px] lg:w-[280px] xl:w-[325px] bg-opacity-5"
              >
                <div
                  class="relative flex flex-col items-center justify-center pt-2 lg:px-6 lg:py-4 rounded-3xl"
                >
                  <div
                    class="bg-gradient-to-tl w-[70px] lg:w-[146px] from-[#01CCFF] to-[#9A36F8] -mt-[78px] lg:-mt-[120px] -ml-10 h-[70px] lg:h-[146px] rounded-full overflow-hidden top-0 translate-x-4"
                  >
                    <div
                      class="absolute inset-0 m-[2px] bg-[#484C97] flex items-center justify-center overflow-hidden rounded-full"
                    >
                      <div
                        class="bg-gradient-to-t flex justify-center from-[#04022E] to-[#04022E] h-full w-full rounded-full"
                      >
                        <h2
                          class="my-auto text-[#01CCFF] font-black text-center text-[32px] leading-[38px] lg:text-[48px] lg:leading-[58px]"
                          style="font-family: Lato, sans-serif"
                        >
                          2nd
                        </h2>
                      </div>
                    </div>
                  </div>
                  <div
                    class="flex flex-col items-center justify-center w-full mt-4 lg:mt-9"
                  >
                    <p
                      class="bg-gradient-to-r from-[#01CCFF] to-[#9A36F8] text-transparent bg-clip-text lg:text-base text-sm font-bold overflow-hidden max-w-[130px] md:max-w-full text-ellipsis whitespace-nowrap"
                      style="font-family: Russo One, system-ui"
                    >
                      {{ top3.length > 0 ? getMaskedUsername(top3[1]?.username) : "" }}
                    </p>
                    <p
                      class="text-white text-lg lg:text-[32px] lg:leading-[38px] mt-3 lg:mt-8 font-bold overflow-hidden max-w-[130px] md:max-w-full text-ellipsis whitespace-nowrap"
                      style="font-family: Lato, sans-serif"
                    >
                      {{
                        top3.length > 0 && top3[1]
                          ? getCurrencyFormatted(top3[1]?.wagered)
                          : ""
                      }}
                    </p>
                    <p
                      class="mt-1 text-sm font-bold text-white uppercase lg:text-base"
                      style="font-family: Lato, sans-serif"
                    >
                      Wager
                    </p>
                    <div
                      class="mt-[29px] lg:mt-[43px] relative px-[26px] py-1 lg:py-2 lg:px-12 xl:px-16 w-full"
                    >
                      <img
                        src="../assets/prize-button.png"
                        class="absolute top-0 left-0 w-full h-[43px] md:h-[72px]"
                        alt="Reward"
                      />
                      <p
                        class="text-[#01CCFF] font-black text-2xl md:mt-4 lg:mt-0 lg:text-[48px] lg:leading-[58px] text-center"
                        style="font-family: Lato, sans-serif"
                      >
                        {{ getRewardValue(1) }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-motion-pop-visible
              class="absolute flex flex-col items-center border-t border-b border-solid md:h-[260px] lg:h-full lg:-mt-40 top-2 lg:relative shadow-[4px_4px_30px_3px_rgba(154,54,248,1),-4px_-4px_30px_3px_rgba(154,54,248,1)]"
              style="border-image: linear-gradient(to left, #01ccff, #9a36f8) 1"
            >
              <div
                class="p-2.5 pb-[13px] md:pb-1 bg-gradient-to-r rounded-none w-[150px] md:w-[200px] lg:w-[280px] xl:w-[325px] bg-opacity-5"
              >
                <div
                  class="relative flex flex-col items-center justify-center pt-2 lg:px-6 lg:py-4 rounded-3xl"
                >
                  <div
                    class="bg-gradient-to-tl w-[70px] lg:w-[146px] from-[#01CCFF] to-[#9A36F8] -mt-[78px] lg:-mt-[120px] -ml-10 h-[70px] lg:h-[146px] rounded-full overflow-hidden top-0 translate-x-4"
                  >
                    <div
                      class="absolute inset-0 m-[2px] bg-[#04022E] flex items-center justify-center overflow-hidden rounded-full"
                    >
                      <div
                        class="bg-gradient-to-t flex justify-center from-[#04022E] to-[#04022E] h-full w-[60px] rounded-full"
                      >
                        <h2
                          class="my-auto text-[#01CCFF] font-black text-center text-[32px] leading-[38px] lg:text-[48px] lg:leading-[58px]"
                          style="font-family: Lato, sans-serif"
                        >
                          1st
                        </h2>
                      </div>
                    </div>
                  </div>
                  <div
                    class="flex flex-col items-center justify-center w-full mt-4 lg:mt-9"
                  >
                    <p
                      class="bg-gradient-to-r from-[#01CCFF] to-[#9A36F8] text-transparent bg-clip-text lg:text-base text-sm font-bold overflow-hidden max-w-[130px] md:max-w-full text-ellipsis whitespace-nowrap"
                      style="font-family: Russo One, system-ui"
                    >
                      {{ top3.length > 0 ? getMaskedUsername(top3[0]?.username) : "" }}
                    </p>
                    <p
                      class="text-white text-lg lg:text-[32px] lg:leading-[38px] mt-3 lg:mt-8 font-bold overflow-hidden max-w-[130px] md:max-w-full text-ellipsis whitespace-nowrap"
                      style="font-family: Lato, sans-serif"
                    >
                      {{
                        top3.length > 0 && top3[0]
                          ? getCurrencyFormatted(top3[0]?.wagered)
                          : ""
                      }}
                    </p>
                    <p
                      class="mt-1 text-sm font-bold text-white uppercase lg:text-base"
                      style="font-family: Lato, sans-serif"
                    >
                      Wager
                    </p>
                    <div
                      class="mt-[29px] lg:mt-[43px] relative px-[26px] py-1 lg:py-2 lg:px-2 w-full"
                    >
                      <img
                        src="../assets/prize-button.png"
                        class="absolute top-0 left-0 w-full h-[43px] md:h-[72px]"
                        alt="Reward"
                      />
                      <p
                        class="text-[#01CCFF] font-black text-2xl md:mt-4 lg:mt-0 lg:text-[48px] lg:leading-[58px] text-center"
                        style="font-family: Lato, sans-serif"
                      >
                        {{ getRewardValue(0) }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-motion-pop-visible
              class="flex flex-col items-center mt-28 md:h-[260px] lg:h-full md:mt-44 lg:mt-[88px] border-t border-b border-solid shadow-[4px_4px_30px_3px_rgba(154,54,248,1),-4px_-4px_30px_3px_rgba(154,54,248,1)]"
              style="border-image: linear-gradient(to left, #01ccff, #9a36f8) 1"
            >
              <div
                class="p-2.5 pb-[13px] md:pb-1 bg-gradient-to-r rounded-none w-[150px] md:w-[200px] lg:w-[280px] xl:w-[325px] bg-opacity-5"
              >
                <div
                  class="relative flex flex-col items-center justify-center pt-2 lg:px-6 lg:py-4 rounded-3xl"
                >
                  <div
                    class="bg-gradient-to-tl w-[70px] lg:w-[146px] from-[#01CCFF] to-[#9A36F8] -mt-[78px] lg:-mt-[120px] -ml-10 h-[70px] lg:h-[146px] rounded-full overflow-hidden top-0 translate-x-4"
                  >
                    <div
                      class="absolute inset-0 m-[2px] bg-[#04022E] flex items-center justify-center overflow-hidden rounded-full"
                    >
                      <div
                        class="bg-gradient-to-t flex justify-center from-[#04022E] to-[#04022E] h-full w-full rounded-full"
                      >
                        <h2
                          class="my-auto text-[#01CCFF] font-black text-center text-[32px] leading-[38px] lg:text-[48px] lg:leading-[58px]"
                          style="font-family: Lato, sans-serif"
                        >
                          3rd
                        </h2>
                      </div>
                    </div>
                  </div>
                  <div
                    class="flex flex-col items-center justify-center w-full mt-4 lg:mt-9"
                  >
                    <p
                      class="bg-gradient-to-r from-[#01CCFF] to-[#9A36F8] text-transparent bg-clip-text lg:text-base text-sm font-bold overflow-hidden max-w-[130px] md:max-w-full text-ellipsis whitespace-nowrap"
                      style="font-family: Russo One, system-ui"
                    >
                      {{ top3.length > 0 ? getMaskedUsername(top3[2]?.username) : "" }}
                    </p>
                    <p
                      class="text-white text-lg lg:text-[32px] lg:leading-[38px] mt-3 lg:mt-8 font-bold overflow-hidden max-w-[130px] md:max-w-full text-ellipsis whitespace-nowrap"
                      style="font-family: Lato, sans-serif"
                    >
                      {{
                        top3.length > 0 && top3[2]
                          ? getCurrencyFormatted(top3[2]?.wagered)
                          : ""
                      }}
                    </p>
                    <p
                      class="mt-1 text-sm font-bold text-white uppercase lg:text-base"
                      style="font-family: Lato, sans-serif"
                    >
                      Wager
                    </p>
                    <div
                      class="mt-[29px] lg:mt-[43px] relative px-[26px] py-1 lg:py-2 lg:px-12 xl:px-16 w-full"
                    >
                      <img
                        src="../assets/prize-button.png"
                        class="absolute top-0 left-0 w-full h-[43px] md:h-[72px]"
                        alt="Reward"
                      />
                      <p
                        class="text-[#01CCFF] font-black text-2xl md:mt-4 lg:mt-0 lg:text-[48px] lg:leading-[58px] text-center"
                        style="font-family: Lato, sans-serif"
                      >
                        {{ getRewardValue(2) }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            v-if="loading == false"
            class="flex items-center justify-center w-full mt-[100px] sm:px-4 md:px-10 lg:mt-[100px] font-black text-white"
          >
            <h1
              v-motion-pop-visible
              class="text-[16px] sm:text-20px md:text-[30px] text-center font-montserrat"
            >
              WAGER MINIMUM OF
              <span
                class="bg-gradient-to-r from-[#01CCFF] to-[#9A36F8] text-transparent bg-clip-text"
              >
                $250</span
              >
              IN ORDER TO GET
              <span
                class="bg-gradient-to-r from-[#01CCFF] to-[#9A36F8] text-transparent bg-clip-text"
              >
                LEADERBOARD PRIZE</span
              >
            </h1>
          </div>

          <div
            class="flex justify-center mt-[80px] lg:mt-[120px] mb:mb-24 bg-transparent mx-auto max-w-[1280px] px-6 md:px-14"
          >
            <table
              class="w-full h-full border-[1px] border-[#04022E] lg:w-full bg-gradient-to-r from-[#04022E] via-[#04022E] to-[#04022E] bg-opacity-5 shadow-[4px_4px_30px_3px_rgba(154,54,248,1),-4px_-4px_30px_3px_rgba(154,54,248,1)]"
              style="border-image: linear-gradient(to left, #01ccff, #9a36f8) 1"
            >
              <thead
                v-motion-slide-visible-bottom
                class="bg-transparent"
                style="font-family: Lato, sans-serif"
              >
                <tr>
                  <th
                    class="text-center px-5 lg:px-[45px] xl:pr-28 xl:pl-12 py-2 md:py-4 text-[#01CCFF] text-[18px] leading-6 font-black md:text-left rounded-l w-1/4"
                  >
                    RANK
                  </th>
                  <th
                    class="px-1 md:px-5 lg:px-[45px] xl:px-24 py-2 md:py-4 text-[#01CCFF] text-[18px] leading-6 font-black text-center w-1/4"
                  >
                    USER
                  </th>
                  <th
                    class="px-0 md:px-5 lg:px-[45px] xl:px-24 py-2 md:py-4 text-[#01CCFF] text-[18px] leading-6 font-black text-center w-1/4"
                  >
                    WAGERED
                  </th>
                  <th
                    class="px-4 text-right lg:px-[45px] xl:pl-28 xl:pr-12 py-2 md:py-4 text-[#01CCFF] text-[18px] leading-6 font-black rounded-r w-1/4"
                  >
                    PRIZE
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-motion-slide-visible-bottom
                  v-for="(item, index) in topRest"
                  :key="index"
                  style="font-family: Lato, sans-serif"
                  class="bg-transparent rounded"
                >
                  <td
                    class="px-5 text-center lg:px-[45px] xl:px-28 xl:pl-12 py-10 whitespace-nowrap text-base font-normal md:text-left uppercase w-1/4"
                  >
                    <div class="text-white tracking-[4px]">
                      {{ getOrdinalSuffix(index + 4) }}
                    </div>
                  </td>
                  <td
                    class="px-2 md:px-5 max-w-[92px] overflow-hidden text-ellipsis md:max-w-full py-10 whitespace-nowrap text-base text-white font-normal text-center tracking-[4px] w-1/4"
                  >
                    {{ getMaskedUsername(item?.username) }}
                  </td>
                  <td
                    class="px-1 md:px-5 max-w-[92px] py-10 whitespace-nowrap text-ellipsis overflow-hidden text-base text-white font-normal text-center tracking-[4px] w-1/4"
                  >
                    {{ getCurrencyFormatted(item.wagered) }}
                  </td>
                  <td
                    class="px-4 text-center md:px-5 lg:px-[45px] xl:px-28 xl:pr-12 py-10 whitespace-nowrap text-base text-white font-black md:text-right tracking-[4px] w-1/4"
                  >
                    {{ getRewardValue(index + 3) }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div
          v-if="loading == false"
          v-motion-pop-visible
          class="flex flex-col justify-center text-white w-full max-w-3xl lg:max-w-7xl mt-8 lg:mt-14 text-sm md:text-base uppercase font-semibold tracking-wider px-2 md:px-4 lg:px-20 font-lato"
        >
          <div>
            Your wagers on Roobet will count towards the leaderboard at the following
            weights based on the games you are playing. This helps prevent leaderboard
            abuse:
          </div>
          <ol class="list-disc mt-4 ml-5">
            <li>
              Games with an RTP of 97% or less will contribute 100% of the amount wagered
              to the leaderboard.
            </li>
            <li>
              Games with an RTP above 97% will contribute 50% of the amount wagered to the
              leaderboard.
            </li>
            <li>
              Games with an RTP of 98% and above will contribute 10% of theamount wagered
              to the leaderboard.
            </li>
            <li>Only slots and housegames count(dice excluded) towards leaderboard.</li>
          </ol>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import axios from "axios";
import moment from "moment-timezone";

export default {
  name: "LeaderboardSection",
  data() {
    return {
      leaderboardData: {},
      leaderboardPrevData: {},
      top3: [],
      topRest: [],
      topForMobile: [],
      timer: "0d 0h 0m 0s",
      timeSegments: [
        { label: "DAYS" },
        { label: "HRS" },
        { label: "MIN" },
        { label: "SEC" },
      ],
      currentLeaderboard: "roobet", // Default to Roobet
      previousLeaderboard: false,
      startDate: null,
      endDate: null,
      notFormattedEndDate: null,
      loading: false,
      timerInterval: null,
      activeTabImage: require("../assets/tab-active.png"),
      inActiveTabImage: require("../assets/tab-inactive.png"),
    };
  },
  watch: {
    previousLeaderboard(newSelected) {
      this.activeTabImage = newSelected
        ? require("../assets/tab-inactive.png")
        : require("../assets/tab-active.png");
      this.inActiveTabImage = newSelected
        ? require("../assets/tab-active.png")
        : require("../assets/tab-inactive.png");

      this.changeLeaderboard(); // Update leaderboard data on toggle change
      this.startTimer(); // Restart timer when leaderboard changes
    },
    currentLeaderboard() {
      this.fetchLeaderboard(); // Fetch leaderboard when `currentLeaderboard` changes
      this.startTimer(); // Restart timer when leaderboard changes
    },
  },
  methods: {
    // Fetch leaderboard data for Roobet and RainGG
    async fetchLeaderboard() {
      this.loading = true;

      // Clear old data to prevent displaying stale results
      this.leaderboardData = {};
      this.leaderboardPrevData = {};
      this.top3 = [];
      this.topRest = [];
      this.topForMobile = [];

      const baseUrl = process.env.VUE_APP_BASE_API_DYNAMIC;
      const apiKey = process.env.VUE_APP_X_API_KEY_DYNAMIC;
      const secretKey = process.env.VUE_APP_X_SECRET_KEY;

      try {
        // Fetch current leaderboard data
        const currentRes = await axios.get(
          `${baseUrl}/api/leaderboard/${this.currentLeaderboard}`,
          {
            headers: {
              "x-api-key": apiKey,
              "x-secret-key": secretKey,
            },
          }
        );

        this.leaderboardData = currentRes.data || {};
        this.startDate = moment(this.leaderboardData.startDate).format("MMMM DD, YYYY");
        this.endDate = moment(this.leaderboardData.endDate).format("MMMM DD, YYYY");
        this.notFormattedEndDate = this.leaderboardData.endDate; // Ensure the end date is updated for timer

        // Fetch previous leaderboard data if enabled for the current leaderboard
        if (this.shouldFetchPreviousLeaderboard()) {
          const previousRes = await axios.get(
            `${baseUrl}/api/leaderboard/${this.currentLeaderboard}?previous=true`,
            {
              headers: {
                "x-api-key": apiKey,
                "x-secret-key": secretKey,
              },
            }
          );
          this.leaderboardPrevData = previousRes.data || {};
        }

        // Normalize leaderboard data
        this.leaderboardData = this.normalizeLeaderboardData(this.leaderboardData);
        this.leaderboardPrevData = this.normalizeLeaderboardData(
          this.leaderboardPrevData
        );

        // Update leaderboard after fetching data
        this.changeLeaderboard();
        this.startTimer(); // Restart the timer after data fetch
      } catch (error) {
        console.error("Error fetching leaderboard data:", error);
      } finally {
        this.loading = false;
      }
    },

    shouldFetchPreviousLeaderboard() {
      if (this.currentLeaderboard === "roobet") {
        return process.env.VUE_APP_SHOW_PREVIOUS_LEADERBOARD_ROOBET === "true";
      } else if (this.currentLeaderboard === "raingg") {
        return process.env.VUE_APP_SHOW_PREVIOUS_LEADERBOARD_RAINGG === "true";
      } else if (this.currentLeaderboard === "packdraw") {
        return process.env.VUE_APP_SHOW_PREVIOUS_LEADERBOARD_PACKDRAW === "true";
      }
      return false;
    },

    normalizeLeaderboardData(data) {
      if (!data?.leaderboard) return { leaderboard: [] };

      return {
        startDate: data.startDate,
        endDate: data.endDate,
        leaderboard: data.leaderboard.map((entry) => ({
          username: this.getUsername(entry),
          wagered: this.getWageredAmount(entry),
        })),
      };
    },

    // Helper function to get the username dynamically for Roobet and RainGG
    getUsername(entry) {
      if (this.currentLeaderboard === "roobet") {
        return entry.username || "";
      } else if (this.currentLeaderboard === "raingg") {
        return entry.username || "";
      } else if (this.currentLeaderboard === "packdraw") {
        return entry.username || "";
      }
      return "";
    },

    // Conditional logic to decide which field to use for wagered amount (Roobet and RainGG)
    getWageredAmount(entry) {
      switch (this.currentLeaderboard) {
        case "roobet":
          return entry.weightedWagered || 0;
        case "packdraw":
          return entry.wagerAmount || 0;
        case "raingg":
          return entry.wagered || 0;
        default:
          return 0;
      }
    },

    toggleLeaderboard(leaderboardType) {
      if (this.currentLeaderboard !== leaderboardType) {
        // Set the current leaderboard to the selected one
        this.currentLeaderboard = leaderboardType;

        // Call changeLeaderboard to update the leaderboard data based on the selected type
        this.changeLeaderboard();
      }
    },

    // Change the leaderboard based on toggle
    changeLeaderboard() {
      const data = this.previousLeaderboard
        ? this.leaderboardPrevData.leaderboard
        : this.leaderboardData.leaderboard;

      this.top3 = data?.slice(0, 3) || [];

      // Conditional slicing based on current leaderboard
      if (this.currentLeaderboard === "raingg") {
        this.topRest = data?.slice(3, 9) || [];
        this.topForMobile = data?.slice(0, 9) || [];
      } else if (this.currentLeaderboard === "packdraw") {
        this.topRest = data?.slice(3, 8) || [];
        this.topForMobile = data?.slice(0, 8) || [];
      } else {
        this.topRest = data?.slice(3, 10) || [];
        this.topForMobile = data?.slice(0, 10) || [];
      }

      // Update the end date to the new leaderboard's end date
      this.notFormattedEndDate = this.previousLeaderboard
        ? this.leaderboardPrevData.endDate
        : this.leaderboardData.endDate;

      // Restart the timer after leaderboard change
      this.startTimer();
    },

    // Get reward value based on the rank
    getRewardValue(rank) {
      const isPrevious = this.previousLeaderboard;
      const rewardsKey = `VUE_APP_${this.currentLeaderboard.toUpperCase()}_${
        isPrevious ? "PREVIOUS" : "CURRENT"
      }_LEADERBOARD_REWARDS`;
      const prizes = JSON.parse(process.env[rewardsKey] || "[]");

      const value = rank >= prizes.length ? prizes[prizes.length - 1] : prizes[rank];

      return this.currentLeaderboard === "raingg" ? `${value}c` : `$${value}`;
    },

    // Start countdown timer for leaderboard expiry
    startTimer() {
      if (!this.notFormattedEndDate) return;

      clearInterval(this.timerInterval); // Clear any existing intervals

      const periodKey = `VUE_APP_${this.currentLeaderboard.toUpperCase()}_TIMER_PERIOD`;
      const period = process.env[periodKey] || "";

      const getNextTargetDate = () => {
        const now = moment().tz("America/New_York");
        let targetDate = moment
          .utc(this.notFormattedEndDate)
          .tz("America/New_York")
          .subtract(1, "seconds");

        if (now.isAfter(targetDate)) {
          if (period === "week") targetDate.add(1, "week");
          else if (period === "month") targetDate.add(1, "month");
          else if (period === "custom") {
            const customDays = parseInt(
              process.env[`${this.currentLeaderboard.toUpperCase()}_CUSTOM_DAYS`] || "7",
              10
            );
            targetDate.add(customDays, "days");
          }
        }
        return targetDate;
      };

      let targetDate = getNextTargetDate();
      if (!targetDate) return;

      const updateTimer = () => {
        const nowEst = moment().tz("America/New_York");
        const distance = targetDate.diff(nowEst);

        if (distance >= 0) {
          const duration = moment.duration(distance);
          this.timer = `${Math.floor(
            duration.asDays()
          )}d ${duration.hours()}h ${duration.minutes()}m ${duration.seconds()}s`;

          // Map the timer to the segments
          this.timeSegments.forEach((segment, index) => {
            const timeValue = this.timer.split(" ")[index];
            segment.value = timeValue ? timeValue.slice(0, -1) : "0";
          });
        } else {
          this.timer = "0d 0h 0m 0s";
          clearInterval(this.timerInterval); // Stop the timer when the countdown finishes
        }
      };

      updateTimer();
      this.timerInterval = setInterval(updateTimer, 1000); // Set a new interval for the countdown
    },

    // Get masked username
    getMaskedUsername(username) {
      if (!username || typeof username !== "string") {
        return ""; // Fallback for invalid input
      }

      if (username.length <= 2) {
        return username; // If too short, return as is
      }

      const firstChar = username.charAt(0);
      const lastChar = username.charAt(username.length - 1);
      const mask = "*".repeat(username.length - 2); // Mask everything except first & last

      return `${firstChar}${mask}${lastChar}`;
    },

    getCurrencyFormatted(value) {
      const formatted = Number(value).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });

      if (
        this.currentLeaderboard === "roobet" ||
        this.currentLeaderboard === "packdraw"
      ) {
        return `$${formatted}`;
      } else if (this.currentLeaderboard === "raingg") {
        return `${formatted}c`;
      }

      return formatted;
    },

    // Get ordinal suffix for the rank
    getOrdinalSuffix(n) {
      const s = ["th", "st", "nd", "rd"],
        v = n % 100;
      return n + (s[(v - 20) % 10] || s[v] || s[0]);
    },

    // Check if it's mobile
    isMobile() {
      return window.innerWidth < 768;
    },
  },
  mounted() {
    this.fetchLeaderboard();
  },
};
</script>

<style scoped>
.toggle-switch {
  position: relative;
  display: inline-flex;
  justify-content: space-between;
  flex-direction: column;
  align-items: center;
  width: 632px;
  height: 72px;
  border: 2px #2cceee;
  /* background: linear-gradient(to right, #121212, #461B83 , #121212); */
  border-radius: 20px;
  padding: 0 8px;
  cursor: pointer;

  @media screen and (max-width: 640px) {
    width: 300px;
    height: 74px;
  }
}

.toggle-switch input {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}

.toggle-switch .slider {
  position: absolute;
  left: 0;
  top: 2px;
  border-radius: 10px;
  width: 300px;
  height: 72px;
  background: url("../assets/tab-active.png") no-repeat;
  background-color: #00c3ff;
  /* border-radius: 24px; */
  transition: transform 0.3s ease;
  box-shadow: -4px -4px 15px 3px rgba(0, 195, 255, 0.5),
    4px 4px 15px 3px rgba(0, 178, 209, 0.5);
}

.toggle-switch input:checked + .slider {
  transform: translateX(330px);

  @media screen and (max-width: 640px) {
    transform: translateY(100px);
  }
}

.toggle-switch span {
  font-size: 35px;
  font-weight: bold;
  z-index: 1;
  padding: 0 8px;
}

.toggle-switch .left-label {
  position: absolute;
  left: 0px;
  margin-top: 5px;
  font-weight: 50;

  @media screen and (max-width: 640px) {
    top: 0;
    /* left: 100px; */
  }
}

.toggle-switch .right-label {
  position: absolute;
  right: 2px;
  margin-top: 5px;
  font-weight: 50;
  @media screen and (max-width: 640px) {
    bottom: -80px;
    /* left: 100px; */
  }
}

.custom-border {
  opacity: 1;
  margin: 10px;
  border: solid 2px transparent;
  border-radius: 10px;
  background-image: linear-gradient(#090b2a, #090b2a),
    linear-gradient(to bottom, #ed3c80, #3e6b3e);
  background-origin: border-box;
  background-clip: padding-box, border-box;
  /* background: url('../assets/tab-active.png') no-repeat; rgba(159,84,249,0) */
}
</style>
